// extracted by mini-css-extract-plugin
export default {"root":"_3nunm","normal":"_1tv5a","tier-link":"_3zuMk","tierLink":"_3zuMk"};